import type { Buffer } from "../model/buffer";
import type { Range } from "../model/range";
import type { OperatorResult } from "./delete";
import { extractCharRange, normalizeRange, toExclusiveEnd } from "./range-edit";

/** `y`: Rangeの内容をレジスタへコピーする。バッファは変更しない。 */
export function applyYank(buffer: Buffer, range: Range): OperatorResult {
  const { from, to } = normalizeRange(range);

  if (range.kind === "linewise") {
    const lines = buffer.lines.slice(from.line, to.line + 1);
    return { buffer, cursor: from, content: { lines, linewise: true } };
  }

  const exclusiveTo = range.kind === "inclusive" ? toExclusiveEnd(buffer, to) : to;
  const lines = extractCharRange(buffer, from, exclusiveTo);
  return { buffer, cursor: from, content: { lines, linewise: false } };
}
